// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__36ytr","colCheckbox":"styles_colCheckbox__2EW5v"};